import { call, put, all, takeEvery, select } from "redux-saga/effects";

import { tourActions } from '../slice/tourSlice'
import { getAllByAdminApi, createApi, updateApi, deleteApi, getRandomApi } from 'services/tourServices'
import { newsSelector } from "redux/selector"


function* handleGetTour(action) {
    try {
        const res = yield call(getAllByAdminApi, action.payload.query, action.payload.sort, action.payload.currentPage, action.payload.tourType)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourActions.getTourSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(tourActions.getTourFailed())
            }
        }
        else {
            yield put(tourActions.getTourFailed())
        }
    } catch (error) {
        yield put(tourActions.getTourFailed())
    }
}

function* handleGetRandomTour() {
    try {
        const res = yield call(getRandomApi)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourActions.getTourRandomSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(tourActions.getTourRandomFailed())
            }
        }
        else {
            yield put(tourActions.getTourRandomFailed())
        }
    } catch (error) {
        yield put(tourActions.getTourRandomFailed())
    }
}



function* handleCreateTour(action) {
    try {
        const res = yield call(createApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourActions.addTourSuccess())
                action.payload.ShowToast('success', 'Thêm tour thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(tourActions.getTour({ query: action.payload.querySearch, sort: action.payload.sort, currentPage: action.payload.currentPage, tourType: action.payload.tourType }))
            } else {
                yield put(tourActions.addTourFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Thêm tour thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourActions.addTourFailed())
            action.payload.ShowToast('error', 'Thêm tour thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourActions.addTourFailed())
        action.payload.ShowToast('error', 'Thêm tour thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateTour(action) {
    try {
        const res = yield call(updateApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourActions.updateTourSuccess())
                action.payload.ShowToast('success', 'Cập nhật tour thành công!')
                action.payload.hidden()
                action.payload.handleSetDefaultForm()
                yield put(tourActions.getTour({ query: action.payload.querySearch, sort: action.payload.sort, currentPage: action.payload.currentPage, tourType: action.payload.tourType }))


            } else {
                yield put(tourActions.updateTourFailed())
                action.payload.setFieldError(response.data[0], response.data[1])
                action.payload.ShowToast('error', 'Cập nhật tour thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourActions.updateTourFailed())
            action.payload.ShowToast('error', 'Cập nhật tour thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourActions.updateTourFailed())
        action.payload.ShowToast('error', 'Cập nhật tour thất bại, vui lòng thử lại sau!')
    }
}



function* handleRemoveTour(action) {
    try {
        const res = yield call(deleteApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourActions.removeTourSuccess())
                const newsState = yield select(newsSelector)
                let totalPage = newsState.totalPage
                if (newsState.newsList.length === 1) {
                    totalPage = totalPage - 1
                    yield put(tourActions.setTotalPage(totalPage))
                    action.payload.setCurrentPage(action.payload.currentPage - 1)
                    yield History.navigate(`/admin/tour?page=${action.payload.currentPage - 1}`);
                }
                action.payload.ShowToast("success", 'Xóa tour thành công!')
                yield put(tourActions.getTour({ query: action.payload.querySearch, sort: action.payload.sort, currentPage: action.payload.currentPage, tourType: action.payload.tourType }))

            } else {
                yield put(tourActions.removeTourFailed())
                action.payload.ShowToast('error', `${response.data[1]}`)
            }
        }
        else {
            yield put(tourActions.removeTourFailed())
            action.payload.ShowToast('error', `Xóa tour thất bại, tour đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
        }
    } catch (error) {
        yield put(tourActions.removeTourFailed())
        action.payload.ShowToast('error', `Xóa tour thất bại, tour đang được sử dụng hoặc có lỗi xảy ra, vui lòng thử lại sau!`)
    }
}


export default function* tourSaga() {
    yield all(
        [
            takeEvery(tourActions.getTour.type, handleGetTour),
            takeEvery(tourActions.addTour.type, handleCreateTour),
            takeEvery(tourActions.updateTour.type, handleUpdateTour),
            takeEvery(tourActions.removeTour.type, handleRemoveTour),
            takeEvery(tourActions.getTourRandom.type, handleGetRandomTour),
        ]
    )
}
